import LinksTo from 'ember-route-state/components/links-to.gjs';

import LinksToLink from 'rise-ui/components/links-to-link.gjs';

export function initialize(appInstance) {
  LinksTo.setAnchor(LinksToLink);
}

export default {
  initialize,
};
